<template>
  <a-modal
    title="文件查看"
    style="top: 20px;"
    :width="1000"
    v-model="visible5"
    :confirmLoading="confirmLoading"
    :footer="false"
    :maskClosable="false"
  >
    <div class="pdf" v-show="fileType === 'pdf'">
      <p class="arrow" style="display: flex;justify-content: space-around">
        <a-button @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</a-button>
        {{currentPage}} / {{pageCount}}
        <a-button @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</a-button>
      </p>
      <pdf
        :src="src"
        :page="currentPage"
        @num-pages="pageCount=$event"
        @page-loaded="currentPage=$event"
        @loaded="loadPdfHandler">
      </pdf>

    </div>
  </a-modal>
</template>

<script>
  import pdf from 'vue-pdf'
    export default {
        name: "PDFmodel",
      components:{
        pdf
      },
      data(){
          return{
            currentPage: 0, // pdf文件页码
            pageCount: 0, // pdf文件总页数
            fileType: 'pdf', // 文件类型
            src: '', // pdf文件地址
            visible5:false,//文件查看
          }
      },
      methods:{
        // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
        changePdfPage (val) {
          // console.log(val)
          if (val === 0 && this.currentPage > 1) {
            this.currentPage--
            // console.log(this.currentPage)
          }
          if (val === 1 && this.currentPage < this.pageCount) {
            this.currentPage++
            // console.log(this.currentPage)
          }
        },

        // pdf加载时
        loadPdfHandler (e) {
          this.currentPage = 1 // 加载的时候先加载第一页
        },
        //查看
       async delsee(src){
          this.$nextTick(()=>{
            this.src=src
            this.visible5=true
          })

        },
      }

    }
</script>

<style scoped>

</style>